package com.example.mystybag.core.model

data class CapitalizeButtons(
    val positiveButton  : Boolean = true,
    val negativeButton  : Boolean = true
)